<template>
  <v-row no-gutters>
    <v-col cols="4">
      <span v-if="item.label"></span>
      {{ item.label }}
      <v-chip variant="outlined" label class="ml-2 pl-2 pr-2" size="small">
        Uniform load
      </v-chip>
    </v-col>
    <v-col v-if="!open" class="mt-1 text--secondary"
           cols="8"
    >
      <v-fade-transition leave-absolute>
        <v-row>
          <v-col class="border-right center">
            <div>
              <small> Start </small>{{ item.start }}
            </div>

          </v-col>

          <v-col class="border-right center">
            <div>
              <small> End </small>{{ item.end }}
            </div>
          </v-col>

          <v-col class="border-right center">
            <div>
              <small> Magn.</small>
              {{ item.magnitude }}
            </div>

          </v-col>
          <v-col class="center">
            <div>
              <small> Spread </small>
              {{ item.spread }}
            </div>
          </v-col>
        </v-row>
      </v-fade-transition>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'UniformLoadHeader',
  props: {
    item: {},
    open: {}
  }
}
</script>
<style scoped>
.border-right {
  border-right: solid 1px rgba(0, 0, 0, 0.25);
}

</style>